<template>
    <main class="radio-group" :class="{ 'active-require': showRequire }" :id="id">
        <!-- <h5 class="stem">
            问题
            <span>{{ current }}</span>
            <span class="sub">/ {{ all }}</span>
        </h5> -->
        <div class="stem-title">
            <span class="index">{{ current }}. </span>
            <p class="title" :ref="id" v-html="title"></p>
        </div>
        <p class="desc" v-html="desc"></p>
        <Radio
            v-for="(option, index) in options"
            :key="option.optionIdentifier"
            :title="`${index + 1}. ` + option.optionContent"
            :desc="option.optionDesc"
            :id="option.optionIdentifier"
            :value="checkOption.id"
            :option="option"
            :type="'radio-group'"
            @on-change="handleRadioChange"
        />
        <div v-if="showRequire" class="require-tip">{{ requireTip }}</div>
    </main>
</template>

<script>
import { mapState } from 'vuex';
import { ImagePreview } from 'vant';
import { QuestionRequire } from '@/libs/enum';
import Radio from './Radio';

export default {
    name: 'radio-group',
    components: {
        Radio
    },
    props: {
        value: {
            type: [String, Number],
            default: null
        },
        title: {
            type: String,
            default: null
        },
        desc: {
            type: String,
            default: null
        },
        options: {
            type: Array,
            default: () => [],
            require: true
        },
        all: {
            type: Number,
            default: 0
        },
        current: {
            type: Number,
            default: 0
        },
        require: {
            // 0 非必填; 1 必填。默认非必填
            type: String,
            default: () => QuestionRequire.no
        },
        id: {
            type: String,
            default: () => '',
            require: true
        },
        question: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        ...mapState(['passValidate']),
        requireTip() {
            if (this.passValidate) {
                return this.passValidate.optionIdentifier
                    ? '此题选项为必填项，请完成'
                    : '此题为必填项，请完成';
            }
            return '此题为必填项，请完成';
        },
        showRequire() {
            if (this.passValidate && this.require === QuestionRequire.yes) {
                // 未选了选项
                if (!this.checkOption.id && this.passValidate.qidentifier) {
                    return true;
                }
                // 选了选项
                if (this.checkOption.id === this.passValidate.optionIdentifier) {
                    const option = this.options.find(
                        opt => this.passValidate.optionIdentifier === opt.optionIdentifier
                    );
                    if (option && !option.inputValue) {
                        return true;
                    }
                    return false;
                }
                return false;
            }
            return false;
        }
    },
    watch: {
        value(n) {
            this.checkOption.id = n;
        }
    },
    data() {
        return {
            checkOption: {
                title: null,
                id: this.value
            }
        };
    },
    methods: {
        handleRadioChange(isCheck, id, title) {
            if (isCheck) {
                this.checkOption = { title, id };
            } else {
                this.checkOption = { title: null, id: null };
            }
            this.$emit('input', this.checkOption.id);
            this.$emit('on-change', this.checkOption.id);
        },
        handleTitleImage(imageUrl) {
            if (imageUrl) {
                ImagePreview({
                    images: [imageUrl],
                    closeable: true
                });
            }
        }
    },
    mounted() {
        // 由于标题，图片是富文本动态渲染进去的，使用原生dom去进行查询访问
        const ref = this.$refs[this.id];
        if (ref) {
            ref.addEventListener(
                'click',
                e => {
                    this.handleTitleImage(e.target.src);
                },
                false
            );
        }
    }
};
</script>
<style lang="scss" scoped>
.radio-group {
    padding: 30px 40px;
    margin: 32px 32px;
    background-color: #fff;
    border-radius: 12px;
    margin-bottom: 32px;
    box-shadow: 0 8px 60px 10px rgba(46, 39, 39, 0.11);
    .stem {
        font-size: 32px;
        color: #ff530d;
        .sub {
            font-size: 26px;
        }
    }
    .stem-title {
        display: flex;
        font-size: 32px;
        .index {
            display: inline-block;
            padding-top: 22px;
            padding-right: 10px;
        }
    }
    .title {
        word-break: break-all;
        font-size: 36px;
        color: #333333;
        padding: 20px 0px;
    }
    .desc {
        font-size: 28px;
        color: #999999;
        padding-bottom: 20px;
        word-break: break-all;
    }
    .require-tip {
        background-color: #ffe5e0;
        color: red;
        font-size: 28px;
        padding: 15px 0 15px 30px;
        text-align: left;
        border-radius: 5px;
    }
}
.active-require {
    border: dashed 2px red;
}
</style>
<style lang="scss">
.stem-title .title img {
    max-width: 100%;
    height: auto;
}
</style>
